<template>
  <div class="d d_xm">
    <headers :goBack="goBack" />
    <template v-if="list">
      <form5 :list="list" />
      <div-footer :status="status" :isShow="true" :formId="5" :id="id" />
    </template>
    <template v-else>
      <van-empty description="暂无相关数据" />
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getsubmitData } from "@/service/form";
import { format } from "@/common/js/utils";
import divFooter from "@/components/Footer";
import headers from "@/components/Header";
import form5 from "@/components/form/Form5";
// import { Dialog } from "vant";
export default {
  name: "detailForm5",
  components: { divFooter, headers, form5 },
  beforeRouteEnter(to, from, next) {
    console.log(to.path, from.path);
    next((vm) => {
      // vm 是当前组件的实例
      const zUrl = ["/info/wtg", "info/ytj"];
      if (zUrl.indexOf(from.path) !== -1) {
        vm.isShowTips = true;
      }
    });
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      isShowTips: false,
      id: null,
      formId: null,
      status: 0,
      redScarfMedal: null,
      twoStar: null,
      twoOrThreeStar: null,
      threeStar: null,
      fourStar: null,
      list: {},
    });

    onMounted(async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      if (code == 10000 && data) {
        const newObj = {};
        for (const i of data.list) {
          newObj[i.fieldCode] = i.value;
        }
        state.list = newObj;
        //   赋值
        Object.assign(state, newObj);
        state.id = data.id;
        state.status = data.status;
        if (state.isShowTips) {
          // tips(data.status);
        }
      }
    });
    // const tips = (status) => {
    //   let msg = "";
    //   switch (status) {
    //     case 0:
    //       msg = "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~";
    //       break;
    //     case 1:
    //       msg = "您提交的信息已通过审核并计入统计结果";

    //       break;
    //     case 2:
    //       msg = "您提交的信息未通过审核，请修改后重新提交";
    //       break;
    //   }
    //   if (msg !== "") {
    //     Dialog.alert({
    //       message: msg,
    //     }).then(() => {});
    //   }
    // };

    const goBack = () => {
      router.go(-1);
    };
    return {
      ...toRefs(state),
      format,
      goBack,
    };
  },
};
</script>
<style lang="less" scoped></style>
